import viewsEnabled from './viewsEnabled';
import selectedCategories from './setSelectedCategories';

export default [
  viewsEnabled,
  selectedCategories,
];



// WEBPACK FOOTER //
// ./app/services/verification/index.js